export enum UserType {
  IP = 'IP',
  HP = 'HP',
  MA = 'MA',
}
